<app-accessory-config-list-widget [autoFocusSearch]="false"></app-accessory-config-list-widget>